import script from "./wrapper-table.vue?vue&type=script&setup=true&lang=js"
export * from "./wrapper-table.vue?vue&type=script&setup=true&lang=js"

import "./wrapper-table.vue?vue&type=style&index=0&id=fc7f7d46&scoped=true&lang=scss"

import exportComponent from "/Users/vadimkholodov/Documents/GitHub/vahta-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc7f7d46"]])

export default __exports__